<template>
	<form-field-wrap
			:field-props="fieldProps"
			:field-value="isMultiple ? false : fieldValue"
			:is-error="isError"
			:is-switch="isSwitch"
			:input-focus="inputFocus"
			:with-label="fieldProps.withLabel"
	>
		<vue-select :value="fieldValueMultiple"
					:options="ajaxValues"
					:placeholder="fieldProps.PLACEHOLDER"
					:components="{Deselect, OpenIndicator}"
					@search="onSearch"
					@input="changeValue"
					@search:focus="labelSwitch('focus')"
					@search:blur="labelSwitch"
					v-validate="rules"
					:data-vv-as="fieldProps.TITLE"
					:name="fieldProps.CODE"
					v-if="isMultiple"
					:multiple="true"
					:filterable="false"
		>
			<template slot="no-options">{{localize.FIELD_SELECT_AJAX_PLACEHOLDER}}</template>
			<template slot="option" slot-scope="option">
				<span v-html="option.label"></span>
			</template>
			<template slot="selected-option" slot-scope="option">
				<span v-html="option.label"></span>
			</template>
		</vue-select>
		<vue-select :value="fieldValue"
					:options="fieldProps.VALUES"
					:placeholder="fieldProps.PLACEHOLDER"
					:components="{Deselect, OpenIndicator}"
					:input-id="fieldProps.ID ? fieldProps.ID : fieldProps.CODE"
					v-validate="rules"
					:data-vv-as="fieldProps.TITLE"
					:name="fieldProps.CODE"
					:disabled="disable"
					@input="changeValue"
					@search:focus="labelSwitch('focus')"
					@search:blur="labelSwitch"
					v-else
		>
			<template slot="no-options">{{localize.FIELD_SELECT_EMPTY_OPTIONS}}</template>
			<template slot="option" slot-scope="option">
				<span v-html="option.label"></span>
			</template>
			<template slot="selected-option" slot-scope="option">
				<span v-html="fieldValue"></span>
			</template>
		</vue-select>
	</form-field-wrap>
</template>

<script>
	import {Vue} from "ui.vue";

	export default {
		name: "FormFieldSelect",
		data: function () {
			return {
				inputFocus: false,
				error: false,
				selected: {},
				Deselect: {
					render: createElement => createElement('span', {
						domProps: {
							innerHTML: '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10">\n' +
								'    <path d="M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z"/>\n' +
								'  </svg>'
						}
					})
				},
				OpenIndicator: {
					render: createElement => createElement('span', {
						class: {'select_toggle b-filter__icon': true},
						domProps: {
							innerHTML: '<i class="icon icon--arrow-down"></i>'
						},
					})
				},
				ajaxValues: [],
				loading: false,
			}
		},
		created: function () {
			this.updateSelectedOption(this.value);
		},
		watch: {
			value(newValue, oldValue) {
				this.updateSelectedOption(newValue);
			},
		},
		computed: {
			fieldValue() {
				return this.selected ? this.selected.label : "";
			},
			fieldValueMultiple() {
				return this.selected;
			},
			localize() {
				return Object.freeze(Vue.getFilteredPhrases("FIELD_SELECT_"));
			},
			isMultiple() {
				return this.fieldProps.hasOwnProperty('MULTIPLE') && this.fieldProps.MULTIPLE;
			},
			isAjax() {
				return this.fieldProps.hasOwnProperty('ITEMS_ACTION') && this.fieldProps.ITEMS_ACTION
					&& this.fieldProps.hasOwnProperty('ITEMS_COMPONENT_ACTION') && this.fieldProps.ITEMS_COMPONENT_ACTION;
			}
		},
		methods: {
			changeValue(option) {
				if (this.isMultiple) {
					this.selected = option;

					let labels = [], availableIds = [];

					this.fieldProps.VALUE_DATA.forEach((option) => {
						availableIds.push(option.ID);
					});

					this.selected.forEach((option) => {
						labels.push(option.ID);
						if (!availableIds.includes(option.ID)) {
							this.fieldProps.VALUE_DATA.push(option);
						}
					});
					this.$emit('input', labels);

					return;
				}

				this.selected = option;
				this.$emit('input', option ? option.ID : '');
			},
			updateSelectedOption(newValue) {
				let selected;
				if (this.isMultiple) {
					selected = [];
					let values = (this.fieldProps.hasOwnProperty('VALUES'))
						? this.fieldProps.VALUES
						: (this.fieldProps.hasOwnProperty('VALUE_DATA') ? this.fieldProps.VALUE_DATA : [])

					let selectedIds = [];
					values.forEach((option) => {
						if (newValue.includes(option.ID)) {
							selected.push(option);
							selectedIds.push(option.ID);
						}
					});

					this.ajaxValues.forEach((option) => {
						if (newValue.includes(option.ID) && !selectedIds.includes(option.ID)) {
							selected.push(option);
						}
					});
				} else {
					selected = false;
					this.fieldProps.VALUES.forEach((option) => {
						if (newValue == option.ID) {
							selected = option;
						}
					});
				}

				this.$nextTick(() => {
					this.selected = selected;
				});
			},
			onSearch(find) {
				if (!this.isAjax || find.length <= 0) {
					return;
				}

				this.loading = true;

				BX.ajax.runComponentAction(this.fieldProps.ITEMS_COMPONENT_ACTION, this.fieldProps.ITEMS_ACTION, {
					mode: 'class',
					data: {
						find: find
					}
				}).then((response) => {
					this.ajaxValues = response.data;
					this.loading = false;
				}).catch((response) => {
					console.error(response);
					this.loading = false;
				});
			}
		}
	}
</script>